export const fullName = 'Kaleb Luedtke';
export const copyright = `\xA9 ${BUILD_DATE}; Kaleb C. Luedtke`;
export const socials = {
    github: 'https://github.com/Trenly',
    linkedin: 'https://www.linkedin.com/in/kalebluedtke',
    stackExchange: 'https://stackexchange.com/users/13810120/trenly?tab=accounts'
};
